import { render, staticRenderFns } from "./PortalTypesPopup.vue?vue&type=template&id=12fd7db6"
import script from "./PortalTypesPopup.vue?vue&type=script&lang=js"
export * from "./PortalTypesPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports